import { object, string, TypeOf } from 'yup'

export const groupSchema = object({
  name: string().required('グループネームは必須です。').default(''),
}).defined()

export type GroupFormValues = TypeOf<typeof groupSchema>
